import { create } from 'zustand'
import { fetchReleaseKeys } from '@/lib/release-keys'

interface ReleaseKeysState {
  /** Chave -> ligada. Chave ausente lê desligada. */
  keys: Record<string, boolean>
  /** `true` depois da primeira resposta (ou falha) — só informativo. */
  loaded: boolean
  /** Carrega do motor (chamar depois do login). Falha -> tudo desligado. */
  load: () => Promise<void>
  /** Falha fechada: ausente, erro ou não-`true` => `false`. */
  isReleased: (key: string) => boolean
  reset: () => void
}

export const useReleaseKeysStore = create<ReleaseKeysState>()((set, get) => ({
  keys: {},
  loaded: false,
  load: async () => {
    const keys = await fetchReleaseKeys()
    set({ keys, loaded: true })
  },
  isReleased: (key) => get().keys[key] === true,
  reset: () => set({ keys: {}, loaded: false }),
}))

/** Hook reativo: re-renderiza quando a chave muda. */
export function useIsReleased(key: string): boolean {
  return useReleaseKeysStore((s) => s.keys[key] === true)
}
